import {
	ResponseMESF,
	getMomentTz,
	useUTLSettingsContext,
} from "@dexteel/mesf-core";
import { Box, Divider, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { get } from "lodash-es";
import { useState } from "react";
import { useDataEntryContext } from "../../../context/reducer.provider";
import { useTimerContext } from "../../../context/timer.provider";
import { useEAFDataEntryActions } from "../../../hooks/useEAFDataEntryActions";
import { readWireAdditionsFromPLC } from "../../../repositories/eaf.repositories";
import { CreateWireAddition } from "../../modals/wire-addition/CreateWireAddition";
import { EditWireAddition } from "../../modals/wire-addition/EditWireAddition";
import { AgGridFooterActions } from "../components/AgGridFooterActions";
import { useEAFDETablesStyles } from "../styles/useEAFDETablesStyles";
import { useTableData } from "./hooks/useWireAdditionsDataTable";

const moment = getMomentTz();
export const TableWireAdditions = () => {
	const { state } = useUTLSettingsContext();
	const EAF_DE_MAX_WIRE_ADDITIONS = get(
		state.settings,
		"EAF_DE_MAX_WIRE_ADDITIONS",
		10,
	);

	const {
		state: { deProcess, isProcessTimesLoading },
		actions: { setErrorMessage },
	} = useDataEntryContext();
	const { deleteWireAddition, refreshData } = useEAFDataEntryActions();
	const { pause, resume } = useTimerContext();

	const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
	const [showEditModal, setShowEditModal] = useState<boolean>(false);
	const [selectedWireAddition, setSelectedWireAddition] = useState<any>();

	const wireAdditions = deProcess?.wireAdditions;
	const rowCount = wireAdditions ? wireAdditions.length : 0;
	const classes = useEAFDETablesStyles({ rowCount });
	const hasMaxWireAdditions =
		(wireAdditions && wireAdditions.length >= EAF_DE_MAX_WIRE_ADDITIONS) ||
		false;

	const editWireAddition = (WireAdditionId: number) => {
		pause();
		const wireAddition = wireAdditions?.find(
			(a) => a.WireAdditionId === WireAdditionId,
		);
		setSelectedWireAddition(wireAddition);
		setShowEditModal(true);
	};

	const readFromHMI = async () => {
		const ProcessId = deProcess?.process?.ProcessId;
		if (ProcessId) {
			const resp = await readWireAdditionsFromPLC({ ProcessId });
			if (resp.ok) {
				await refreshData();
			} else {
				setErrorMessage(resp.message);
			}
			return resp;
		} else {
			setErrorMessage("Process not found");
			return { ok: false, message: "Process not found" } as ResponseMESF;
		}
	};

	const { columns } = useTableData({
		deleteWireAddition,
		editWireAddition,
	});
	return (
		<>
			<Paper>
				<Box padding={1} className={`${classes.wireAdditionsAgGridBox}`}>
					<AgGridReact
						rowSelection="single"
						suppressRowClickSelection={true}
						pagination={false}
						singleClickEdit={false}
						tooltipShowDelay={0}
						tooltipHideDelay={2000}
						rowData={wireAdditions}
						columnDefs={columns}
						domLayout="normal"
						suppressContextMenu={true}
						loading={isProcessTimesLoading}
						onRowDoubleClicked={(params) => {
							editWireAddition(params.data.WireAdditionId);
						}}
					/>
					<Divider />
					<AgGridFooterActions
						hasMaxItems={hasMaxWireAdditions}
						showCreateModal={showCreateModal}
						setShowCreateModal={setShowCreateModal}
						readFromPLC={readFromHMI}
						table="wireAdditions"
					/>
				</Box>
			</Paper>

			<CreateWireAddition
				show={showCreateModal}
				onHide={() => {
					resume();
					setShowCreateModal(false);
				}}
				date={
					deProcess?.process.End
						? moment(deProcess.process.End).add(10, "minute").toDate()
						: new Date()
				}
			/>
			<EditWireAddition
				show={showEditModal}
				onHide={() => {
					resume();
					setShowEditModal(false);
				}}
				wireAddition={selectedWireAddition}
			/>
		</>
	);
};
